import { SPACING } from '@alto/design-library-tokens';
import { ActionSheetV2, Body, LgPadding, LgSpacing } from '@alto/design-system';
import React, { useEffect } from 'react';
// eslint-disable-next-line import/no-deprecated
import { fetchAncillaries } from '~shared/actions/ancillaries';
import { getAncillariesFromPrescription } from '~shared/helpers/ancillaries';
import { usePrevious } from '~shared/hooks';
import { useDispatchShared, useSelectorShared } from '~shared/store';

type Props = {
  readonly prescriptionID: number;
  readonly medicationName: string;
};

export const AncillaryItemsActionSheet = ({ medicationName, prescriptionID }: Props) => {
  const dispatch = useDispatchShared();
  const prescriptionsWithAncillaries = useSelectorShared((state) => state.ancillaries.ancillaries) || {};
  const hasAncillaries = prescriptionsWithAncillaries[prescriptionID]?.length > 0;
  const previousHasAncillaries = usePrevious(hasAncillaries);

  useEffect(() => {
    // eslint-disable-next-line import/no-deprecated
    if (!previousHasAncillaries && prescriptionID) dispatch(fetchAncillaries(prescriptionID));
  }, [dispatch, prescriptionID, previousHasAncillaries]);

  const prescriptionAncillarySupplies = prescriptionID
    ? getAncillariesFromPrescription(prescriptionsWithAncillaries, prescriptionID)
    : [];

  return (
    <ActionSheetV2
      title="Ancillary items included"
      analyticsName="checkout ancillary items"
    >
      <LgPadding topPadding={SPACING.STATIC.NONE}>
        <Body>We’ll include the necessary supplies to help you administer {medicationName} safely and correctly.</Body>
        {prescriptionAncillarySupplies.length > 0 && (
          <>
            <LgSpacing />
            {prescriptionAncillarySupplies.map((supply) => (
              <Body key={supply.description}>• {supply.description}</Body>
            ))}
          </>
        )}
      </LgPadding>
    </ActionSheetV2>
  );
};
